/** @format */
import { api } from 'utility';
import React, { useState, useEffect } from 'react';
import { Grid, Typography, InputLabel, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {  ConfirmDialog, Icons, CommonTooltip } from 'components';
import createToast from 'components/Toast/Toast';
import UploadDoc from './UploadDoc';
import { LabelLine } from 'components/InputV2/components';
import { useForm } from 'react-hook-form';
import { stringLimitShow } from 'utility';
import { deleteDocService, getHashe } from './services/services';

const UploadFiles = (props) => {
  const classes = useStyles();
  const methods = useForm();

  const {
    label, //نام عنوان بالای آپلود
    tooltip, // توضیحات کنار عنوان
    formData, // دیتای نمایش اررور
    isEditPage =  false,
    multiple = false, // فلگ چند فایلی و تک فایلی
    hasLink = false, // اگر بج ها نیاز به لینک داشته باش=د
    staticName = null, // اگر بج ها نام استاتیک داشته باشد
    setList, // دیتایی که برای ثبت آپلود نیاز است
    beforeUlpoadList, // دیتایی که از ویرایش به کامپوننت میرسد
    loading,
    deleteIcon = null, // کلید نمایش آیکن حذف بج
    type, // نوع صفحه رو مشخص میکنه
    businessStatus, // وضعیت مربوط به بیزینس
    warrantyType, // نوع ضمانت نامه رو مشخص میکند
    documentId, //شناسه اسناد
    documentItemId, //شناسه اسناد
    limitUpload = null, // محدودیت تعداد آپلود
    maxSize = '6', // نمایش متن حداکثر حجم فایل
    acceptsList = 'png, pdf, zip, rar, jpg, jpeg', //  نمایش پسوند فایل قابل آپلود
    withoutRequest, // این کلید به یکسری از صفحات جهت اجازه و جلوگیری از آپلود در لحظه فایل و پیده سازی میکند
    resetUpload = false, // در صورت کال شدن این تابع چیپس های موجود در این کامپوننت ریست میشود

    acceptsFile, //نوع فایل های مجاز
    seData,
    data,
    level,
    onChangeFile = () => { },
    onDeleteItem = () => { },
    fileOtherName,
    setLoadingUpload



  } = props;
  const [fileData, setFile] = useState([]);
  const [isFileUploadLoading, setIsFileUploadLoading] = useState(false);
  const [btnLoadingDialog, setBtnLoadingDialog] = useState(false);
  const [fileHash, setFileHash] = useState([]);
  const [tempData, setTempData] = useState([]);
  const [selectFile, setSelectFile] = useState([]);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [hamdleChange, setHandleChange] = useState(false);
  const [fileSize, SetfileSize] = useState([]);
  const COLOR = [
    {
      value: '#de2429',
      label: 'pdf',
    },
    {
      value: '#ffa726',
      label: 'jpeg',
    },
    {
      value: '#ffa726',
      label: 'jpg',
    },
    {
      value: '#ffa726',
      label: 'png',
    },
    {
      value: '#ffa726',
      label: 'gif',
    },
    {
      value: '#7F56D9',
      label: 'zip',
    },
    {
      value: '#f37736',
      label: 'rar',
    },
    {
      value: '#007c00',
      label: 'csv',
    },
    {
      value: '#007c00',
      label: 'xlsx',
    },
    {
      value: '#1852af',
      label: 'doc',
    },
    {
      value: '#1852af',
      label: 'docx',
    },
    {
      value: '#607D8B',
      label: '',
    },
  ];
  const isTypeFile = (type) => {
    return (
      <div
        className={classes.typeFile}
        style={{ background: COLOR.find((s) => s.label === type)?.value || '#607D8B' }}
      >
        {COLOR.find((s) => s.label === type)?.value ? type : 'XXX'}
      </div>
    );
  };

  // در صورت کال شدن این تابع چیپس های موجود در این کامپوننت ریست میشود
  useEffect(() => {
    if (resetUpload) {
      setFileHash([]);
      setList([]);
      SetfileSize([]);
    }
  }, [resetUpload]);

  // در صورت ویرایش صفحه این کلید فراخوانی میشود
  useEffect(() => {
    if (beforeUlpoadList) {
      if (fileHash?.length === 0) {
        setHandleChange(false);
        setFile([]);
        setTempData(beforeUlpoadList);
        setFileHash(beforeUlpoadList);
      } else {
        setHandleChange(false);
      }
    }
  }, [beforeUlpoadList]);

  // در صورتی که فایل آپلود تک فایلی باشد یک درخواست حذف فراخوانی میشود
  useEffect(() => {
    if (!multiple && tempData?.length === 2) {
      setFileHash([]);
      setIsFileUploadLoading(true);
      deleteFile(true);
    }
  }, [tempData]);

  useEffect(() => {
    if (hamdleChange) {
      if (limitUpload && multiple && fileHash?.length >= limitUpload) {
        createToast('خطا', `آپلود بیش از ${limitUpload} فایل امکان پذیر نمی باشد.`, 'danger');
        return;
      } else onFileChange(fileData);
    }
  }, [fileData]);

  const deleteFile = async (checkFile) => {
    setHandleChange(false);
    setBtnLoadingDialog(true);
    // اگر در لحظه سرویس کال شود
    if (!withoutRequest) {
      const files = {
        fileHashes: [checkFile ? tempData[0] : selectFile?.hash],
        folderHashes: [],
      };
      await deleteDocService(files)
        .then((res) => {
          setHandleChange(false);
          setTempData(tempData.slice(1, 2));
          if (!checkFile) {
            createToast('موفق', 'فایل با موفقیت حذف شد.', 'success');
          }
          setBtnLoadingDialog(false);
          const newFiles = fileHash.filter((d) => {
            return d?.hash !== selectFile?.hash;
          });

          let indexSize = -1;
          let val = selectFile?.size;
          fileHash.find((item, i) => {
            if (item?.size === val) {
              indexSize = i;
              return i;
            }
          });
          let newfileSize = fileSize.filter((_, index) => index !== indexSize);
          setList(newFiles);
          setFile(newFiles);
          SetfileSize(newfileSize);
          setFileHash(newFiles);
          setConfirmDeleteModal(false);
          setIsFileUploadLoading(false);
          onDeleteItem(selectFile)
        })
        .catch((error) => {
          setBtnLoadingDialog(false);
          setIsFileUploadLoading(false);
        });
    } else {
      // اگر در لحظه سرویس کال نشود و کلاینتی خالی شود
      setList([]);
      setFileHash([]);
      SetfileSize([]);
      setConfirmDeleteModal(false);
      setIsFileUploadLoading(false);
      setBtnLoadingDialog(false);
    }
  };

  const convertFileSize = (sizeInBytes) => {
    if (sizeInBytes >= 1073741824) {
      // 1GB
      return (sizeInBytes / 1073741824).toFixed(2) + ' گیگابایت';
    } else if (sizeInBytes >= 1048576) {
      // 1MB
      return (sizeInBytes / 1048576).toFixed(2) + ' مگابایت';
    } else if (sizeInBytes >= 1024) {
      // 1KB
      return (sizeInBytes / 1024).toFixed(2) + ' کیلوبایت';
    } else {
      return sizeInBytes + ' بایت';
    }
  };

  /**
   * زمانیکه کامپوننت انتخاب فایل یه فایلی رو انتخاب میکنیم این تابغ اجرا میشود
   */
  const onFileChange = async (file) => {
    if ((level === 6 || isEditPage) && Array.from(data[level]?.content?.fileUploaded).find(a => a.fileOtherName === fileOtherName.trim())) {
        return createToast(
          'خطا',
          `نام فایل وارد شده تکراری است.`,
          'danger',
        );
    }
    if ((level === 6 || isEditPage) && !fileOtherName.trim().length) {
      return createToast(
        'خطا',
        `عنوان مدرک را وارد نمایید.`,
        'danger',
      );
  }
    setIsFileUploadLoading(true);
    let formData = new FormData();
    formData.append('file', file);
    const fileExtension = '.' + fileData.name.split('.').pop().toLowerCase();
    const acceptedExtensions = acceptsFile
      .toLowerCase()
      .split(',')
      .map((ext) => ext.trim());

    if (!acceptedExtensions.includes(fileExtension)) {
      setIsFileUploadLoading(false);

      return createToast(
        'خطا',
        ` فایل ارسال شده باید در فرمت زیر باشد.
        ${acceptsFile}`,
        'danger',
      );
    }

    if (fileData.size > Number(maxSize + '000000')) {
      setIsFileUploadLoading(false);

      return createToast('خطا', `حجم فایل مورد نظر بیش از ${maxSize} مگابایت می باشد.`, 'danger');
    }
    // اگر در لحظه سرویس کال شود
    if (!withoutRequest) {
      const d = {
        size: Number(maxSize + '000000'),
        type: type,
      };
      if (type === 'WARRANTY') {
        d['warranty-file-type'] = warrantyType;
      }
      if (type === 'BUSINESS') {
        d['document-file-type'] = data[level]?.type;
      }
      if (type === 'BILL') {
        d['document-id'] = documentId;
      }
      setLoadingUpload(true);
      await getHashe(d)
        .then(async (res) => {
          if (res?.result?.uploadHash?.length) {
            await api
              .post(`${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + res?.result?.uploadHash}`, formData)
              .then(async (res) => {
                let data = res?.data?.result;

                SetfileSize((fileSize) => [...fileSize, fileData.size]);
                if (type === 'BILL') {
                  // این سرویس فقط برای آپلود مدارک در صورت حاب ها میباشد
                  //await callMetaData(data, file);
                } else {
                  setIsFileUploadLoading(false);
                  if (!multiple) {
                    setFileHash([data]);
                    setList([data]);
                    SetfileSize([file.size]);
                  } else {
                    setFileHash((oldArray) => [...oldArray, data]);
                    setList((oldArray) => [...oldArray, data]);
                  }
                  setTempData((oldArray) => [...oldArray, data?.hash]);
                  setHandleChange(false);
                  onChangeFile(data);
                  createToast('موفق', 'فایل با موفقیت آپلود شد.', 'success');
                }
                setLoadingUpload(false);
              })
              .catch((error) => {
                setLoadingUpload(false);
                setIsFileUploadLoading(false);
                setHandleChange(false);
              });
          }
        })
        .catch((error) => {
          setLoadingUpload(false);
          setIsFileUploadLoading(false);
          setHandleChange(false);
        });
    } else {
      // اگر در لحظه سرویس کال نشود و با فرم فایل آپلود شود
      setTimeout(() => {
        setIsFileUploadLoading(false);
        setList(file);
        setFileHash([
          {
            name: file.name,
            extension: file?.name?.split('.').pop(),
          },
        ]);
        SetfileSize([file.size]);
      }, 1500);
    }
  };

  // این سرویس فقط برای آپلود مدارک در صورت حاب ها میباشد
  // const callMetaData = async (data) => {
  //   let metaData = {
  //     extension: data?.extension,
  //     fileName: data?.name,
  //     fileType: data?.type,
  //     hashFile: data?.hash,
  //   };
  //   await getMetaData(documentItemId, metaData)
  //     .then(() => {
  //       setIsFileUploadLoading(false);
  //       if (!multiple) {
  //         setFileHash([data]);
  //         setList([data]);
  //         SetfileSize([file.size]);
  //       } else {
  //         setFileHash((oldArray) => [...oldArray, data]);
  //         setList((oldArray) => [...oldArray, data]);
  //       }

  //       setTempData((oldArray) => [...oldArray, data?.hash]);
  //       setHandleChange(false);
  //       createToast('موفق', 'فایل با موفقیت آپلود شد.', 'success');
  //     })
  //     .catch(() => {
  //       setIsFileUploadLoading(false);
  //     });
  // };
  return (
    <>
      <Grid md={12} xs={12} item className={classes.blockUpload}>
        {label && (
          <InputLabel shrink className={classes.label} style={{ display: 'flex' }}>
            <span style={{ color: '#ef5350', margin: '0px 8px 0 8px', fontSize: '19px' }}>*</span>
            <LabelLine
              label={label}
              styleTooltip={classes.customClassUploadTooltip}
              tooltip={tooltip}
            />
          </InputLabel>
        )}
        <div className={classes.fileUlpload}>
          <UploadDoc
            key={fileData[0]}
            disabled={isFileUploadLoading || loading}
            file={''}
            acceptsList={acceptsFile}
            maxSize={maxSize}
            setFile={(f) => {
              setFile(f);
              setHandleChange(true);
            }}
            acceptsFile={acceptsFile}
          />
        </div>

      </Grid>
      <Grid md={12} xs={12} item className={classes.chipBlock}>
        {fileData &&
          data[level]?.content?.fileUploaded.map((item, index) => (
            <>
              <CommonTooltip
                background
                placement="top"
                title={(level === 6 || isEditPage) ? (item?.fileOtherName?.length >= 25 ? item?.fileOtherName : '') : (item?.name?.length >= 25 ? item?.name : '')}
                className={classes.clickable}
              >
                <Chip
                  className={classes.chips}
                  key={1}
                  label={
                    <>
                      <div className={classes.fileType}>
                        <Icons icon="EmptyFile" color="#667585" size="42" />
                        {isTypeFile(String(item?.extension).toLocaleLowerCase())}
                      </div>
                      <Typography>
                        {stringLimitShow(item?.fileOtherName, 25) || stringLimitShow(item?.name, 25)}
                        {item.size && (
                          <>
                            <br />
                            <p className="volume">{convertFileSize(item.size)}</p>
                          </>
                        )}
                      </Typography>
                    </>
                  }
                  onClick={() => {
                    // if (hasLink) {
                    //   let env = process.env?.REACT_APP_ENVIRONMENT;
                    //   window.open(
                    //     `${item?.hash?.indexOf('http') == 0
                    //       ? item?.hash
                    //       : (env == 'production'
                    //         ? 'https://podspace.pod.ir/api/files/'
                    //         : 'https://podspace.sandpod.ir/api/files/') + item?.hash.split('/')
                    //     } `,
                    //     '_blank',
                    //   );
                    // }
                  }}
                  onDelete={() => {
                    setSelectFile(item);
                    setConfirmDeleteModal(true);
                  }}
                  deleteIcon={
                    deleteIcon ? (
                      deleteIcon
                    ) : (
                      <div>
                        <Icons icon="Trash" color="#667585" hover="#D92D20" size="20" />
                      </div>
                    )
                  }
                />
              </CommonTooltip>
            </>
          ))}
      </Grid>
      <ConfirmDialog
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={() => deleteFile(false)}
        title="تایید حذف فایل"
        content="آیا از حذف فایل مطمئن هستید؟"
        confirmButtonText="حذف فایل"
        loading={btnLoadingDialog}
        cancelButtonProps="انصراف"
      />
    </>
  );
};

const useStyles = makeStyles((theme) => {
  return {
    customClassUploadTooltip: {
      position: 'absolute',
      fontSize: '20px',
      bottom: '2px',
    },
    label: {
      fontSize: '17px',
      color: '#455a64',
      marginBottom: 4,
    },
    chipBlock: {
      // maxWidth: '460px',
      width: '100%',
      padding: '10px 0 0 !important',
      textAlign: 'center',
      '@media(max-width: 600px)': {
        maxWidth: '100%',
      },
    },
    blockUpload: {
      // maxWidth: '460px',
      width: '100%',
      padding: '8px 0 0 !important',
      '@media(max-width: 600px)': {
        maxWidth: '100%',
      },
    },
    fileType: {
      width: '36px',
      position: 'relative',
      top: '5px',
    },
    typeFile: {
      width: '30px',
      height: '18px',
      position: 'absolute',
      top: '17px',
      left: '-4px',
      color: '#fff',
      fontSize: '11px',
      lineHeight: '20px',
      borderRadius: '4px',
    },
    chips: {
      marginBottom: 8,
      width: '100%',
      height: '50px',
      display: 'inline-flex',
      justifyContent: ' space-between',
      backgroundColor: '#fff',
      borderRadius: ' 6px',
      border: '2px solid #E2E5E9',
      padding: '0 10px',

      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      '&:focus': {
        backgroundColor: '#fff',
      },
      '&:hover': {
        backgroundColor: '#fff',
      },
      '& .MuiChip-label': {
        display: 'flex',
        gap: '10px',
      },
      '& .MuiInputLabel': {
        width: '88%',
        paddingLeft: 0,
        fontSize: 12,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        whiteSpace: 'nowrap',
        display: 'flex',
        gap: '10px',
      },
      '& .MuiTypography-root': {
        fontSize: 12,
        textAlign: 'left',
        fontWeight: '500 !important',
        margin: '5px 0',
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        justifyContent: 'center',
        '& .volume': {
          fontSize: 11,
          color: '#9AA6B1',
          fontWeight: '100 !important',
        },
      },
    },
  };
});

export default UploadFiles;
